import * as yup from "yup";
import { EmailContents } from "./types";
import moment from "moment";

export const EmailContentsInitialValues: EmailContents = {
  to: [],
  cc: [],
  subject: "",
  message: "",
  attachments: {
    filename: "",
    content: "",
  },
};

export const EmailContentsSchema = yup.object({
  to: yup
    .array()
    .of(yup.string().email("Invalid email address"))
    .required("To field cannot be empty"),
  cc: yup.array().of(yup.string().email("Invalid email address")).optional(),
  subject: yup.string().required("Please add your email subject."),
  message: yup.string().required("Please add your message."),
  attachments: yup.object().nullable(),
});
